import React from 'react';
import Image from 'next/image';
import { Adversary } from '@/lib/adversaries';

type Props = {
  adversary: Adversary;
  isMatched: boolean;
};

export default function AdversaryCardFace({ adversary, isMatched }: Props) {
  return (
    <div
      className={`absolute inset-0 rounded-xl overflow-hidden
        ${isMatched ? 'ring-2 ring-green-400' : ''}`}
    >
      {adversary.image ? (
        <Image
          src={adversary.image}
          alt={`${adversary.name} adversary character`}
          fill
          sizes="(max-width: 768px) 25vw, 150px"
          className="object-cover"
          priority={false}
        />
      ) : (
        <div
          className="w-full h-full flex items-center justify-center"
          style={{ background: `linear-gradient(135deg, ${adversary.primaryColor}55 0%, ${adversary.primaryColor}22 100%)` }}
        >
          <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke={adversary.primaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="4" />
            <path d="M6 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
          </svg>
        </div>
      )}

      {isMatched && (
        <div className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-green-500/80 flex items-center justify-center">
          <svg viewBox="0 0 12 12" width="10" height="10" fill="none">
            <path d="M2 6l3 3 5-5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      )}
    </div>
  );
}